export default __webpack_public_path__ + "static/media/guiaAndroid2.51a50926.png";